"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesLabel = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var useMeasure_1 = require("../../hooks/useMeasure");
var styles_1 = require("../../styles");
var model_1 = require("./model");
var MIN_OFF_SET = 20;
var getOutlierIconOffset = function (widthLabel) {
    var labelWidthOffset = widthLabel + 5;
    return Math.min(labelWidthOffset, MIN_OFF_SET);
};
function SeriesLabel(props) {
    var seriesType = props.seriesType, x = props.x, y = props.y, color = props.color, value = props.value, outlierValue = props.outlierValue;
    var _a = useMeasure_1.useWidth(), refLabel = _a[0], widthLabel = _a[1];
    var theme = styles_1.useTheme();
    switch (seriesType) {
        case model_1.SeriesType.Line:
            var iconOffset = getOutlierIconOffset(widthLabel);
            return (outlierValue === null || outlierValue === void 0 ? void 0 : outlierValue.value) != null ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.Icon, { icon: 'angleUp', scale: 1, x: x - iconOffset, y: y - 25, style: { fill: theme.pallete.status.danger.main } }),
                react_1.default.createElement("text", { ref: refLabel, x: x, y: y, dy: -9, style: { fill: color } }, outlierValue.value))) : (react_1.default.createElement("text", { x: x, y: y, dy: -9, style: { fill: color }, textAnchor: 'middle' }, value));
    }
}
exports.SeriesLabel = SeriesLabel;
//# sourceMappingURL=SeriesLabel.js.map